/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.multi.account.crm.manager.rpc.MultiAccountCrmManagerChirpService
 */
import { createRpcClientV2 } from 'rpc-client-utils';
import { registerQuery } from 'data-fetching-client/next';
import http from 'hub-http/clients/apiClient';
import * as References from './MultiAccountCrmManagerChirpService';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.multi.account.crm.manager.rpc.MultiAccountCrmManagerChirpService#getCompanyRelatedAccounts
 */
export const GET_COMPANY_RELATED_ACCOUNTS_QUERY_FIELD_NAME = 'com_hubspot_multi_account_crm_manager_rpc_MultiAccountCrmManagerChirpService_getCompanyRelatedAccounts';
export const GET_COMPANY_RELATED_ACCOUNTS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_COMPANY_RELATED_ACCOUNTS_QUERY_FIELD_NAME,
  args: ['companyId'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getCompanyRelatedAccountsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.multi.account.crm.manager.rpc.MultiAccountCrmManagerChirpService#getCompanyAssociatedDeals
 */
export const GET_COMPANY_ASSOCIATED_DEALS_QUERY_FIELD_NAME = 'com_hubspot_multi_account_crm_manager_rpc_MultiAccountCrmManagerChirpService_getCompanyAssociatedDeals';
export const GET_COMPANY_ASSOCIATED_DEALS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_COMPANY_ASSOCIATED_DEALS_QUERY_FIELD_NAME,
  args: ['companyId', 'targetPortalId'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getCompanyAssociatedDealsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.multi.account.crm.manager.rpc.MultiAccountCrmManagerChirpService#getCompanyAssociatedContacts
 */
export const GET_COMPANY_ASSOCIATED_CONTACTS_QUERY_FIELD_NAME = 'com_hubspot_multi_account_crm_manager_rpc_MultiAccountCrmManagerChirpService_getCompanyAssociatedContacts';
export const GET_COMPANY_ASSOCIATED_CONTACTS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_COMPANY_ASSOCIATED_CONTACTS_QUERY_FIELD_NAME,
  args: ['companyId', 'targetPortalId'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.getCompanyAssociatedContactsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.multi.account.crm.manager.rpc.MultiAccountCrmManagerChirpService#getCompanyTimeline
 */
export const GET_COMPANY_TIMELINE_QUERY_FIELD_NAME = 'com_hubspot_multi_account_crm_manager_rpc_MultiAccountCrmManagerChirpService_getCompanyTimeline';
export const GET_COMPANY_TIMELINE_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_COMPANY_TIMELINE_QUERY_FIELD_NAME,
  args: ['companyId', 'targetPortalId', 'types', 'startTime', 'stopTime', 'locale'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.getCompanyTimelineRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.multi.account.crm.manager.rpc.MultiAccountCrmManagerChirpService#getCompanyTimelineMeetingDetails
 */
export const GET_COMPANY_TIMELINE_MEETING_DETAILS_QUERY_FIELD_NAME = 'com_hubspot_multi_account_crm_manager_rpc_MultiAccountCrmManagerChirpService_getCompanyTimelineMeetingDetails';
export const GET_COMPANY_TIMELINE_MEETING_DETAILS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_COMPANY_TIMELINE_MEETING_DETAILS_QUERY_FIELD_NAME,
  args: ['targetPortalId', 'companyId', 'meetingId', 'startTime', 'stopTime', 'locale'],
  fetcher(request, ctx) {
    var _ctx$customClient5;
    return ((_ctx$customClient5 = ctx.customClient) !== null && _ctx$customClient5 !== void 0 ? _ctx$customClient5 : chirpClient).call(References.getCompanyTimelineMeetingDetailsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.multi.account.crm.manager.rpc.MultiAccountCrmManagerChirpService#getCompanyTimelineEmailDetails
 */
export const GET_COMPANY_TIMELINE_EMAIL_DETAILS_QUERY_FIELD_NAME = 'com_hubspot_multi_account_crm_manager_rpc_MultiAccountCrmManagerChirpService_getCompanyTimelineEmailDetails';
export const GET_COMPANY_TIMELINE_EMAIL_DETAILS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_COMPANY_TIMELINE_EMAIL_DETAILS_QUERY_FIELD_NAME,
  args: ['targetPortalId', 'companyId', 'trackerKeys', 'startTime', 'stopTime', 'locale'],
  fetcher(request, ctx) {
    var _ctx$customClient6;
    return ((_ctx$customClient6 = ctx.customClient) !== null && _ctx$customClient6 !== void 0 ? _ctx$customClient6 : chirpClient).call(References.getCompanyTimelineEmailDetailsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.multi.account.crm.manager.rpc.MultiAccountCrmManagerChirpService#isConnectedCompany
 */
export const IS_CONNECTED_COMPANY_QUERY_FIELD_NAME = 'com_hubspot_multi_account_crm_manager_rpc_MultiAccountCrmManagerChirpService_isConnectedCompany';
export const IS_CONNECTED_COMPANY_QUERY = /* #__PURE__ */registerQuery({
  fieldName: IS_CONNECTED_COMPANY_QUERY_FIELD_NAME,
  args: ['companyId'],
  fetcher(request, ctx) {
    var _ctx$customClient7;
    return ((_ctx$customClient7 = ctx.customClient) !== null && _ctx$customClient7 !== void 0 ? _ctx$customClient7 : chirpClient).call(References.isConnectedCompanyRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});